import { render } from "./UmsSend.vue?vue&type=template&id=78518284&scoped=true"
import script from "./UmsSend.vue?vue&type=script&lang=js"
export * from "./UmsSend.vue?vue&type=script&lang=js"

import "./UmsSend.vue?vue&type=style&index=0&id=78518284&scoped=true&lang=css"

import exportComponent from "D:\\JSD\\03. 사이트\\JSD_SITE\\clientapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78518284"]])

export default __exports__